import React, { ReactElement } from 'react';
import { ArrowRightIcon, PushkinEntityText } from '@kursk/components/ui/icons';
import styles from "./PushkinBlockForEntity.module.scss";
import { themeValue } from "@kursk/themes";

export function PushkinBlockForEntity(): ReactElement {
  return (
    <div className={styles.wrapper}>
      <a href="/pushkincard" target="_blank" className={styles.iconAndTextBlock}>
        <div>
          <div className={styles.iconWrapper}></div>
          <img src="/images/pushkinForEntity.png" alt=""/>
        </div>
        <div className={styles.textWrapper}>
          <div className={styles.text}>Событие можно оплатить</div>
          <PushkinEntityText />
        </div>

      </a>
      <div className={styles.buttonWrapper}>
        <a href="/pushkincard" target="_blank">
          <div className={styles.button}>
            <span className={styles.button_title}>Подробнее</span>
            {themeValue({
              bel: <></>,
              default: <ArrowRightIcon/>
            })}
          </div>
        </a>

      </div>
    </div>
  );
}
